import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../config/theme';
import { useLanguage } from '../config/language';
import { Search, Car, ChevronLeft, ChevronRight } from 'lucide-react';

// Car brands data with logos
const carBrands = [
  { id: 'toyota', name: 'Toyota', nameAr: 'تويوتا', logo: 'https://www.carlogos.org/car-logos/toyota-logo-2019-3700x1200.png', country: 'Japan' },
  { id: 'nissan', name: 'Nissan', nameAr: 'نيسان', logo: 'https://www.carlogos.org/car-logos/nissan-logo-2020-black.png', country: 'Japan' },
  { id: 'honda', name: 'Honda', nameAr: 'هوندا', logo: 'https://www.carlogos.org/car-logos/honda-logo-1700x1150.png', country: 'Japan' },
  { id: 'lexus', name: 'Lexus', nameAr: 'لكزس', logo: 'https://www.carlogos.org/car-logos/lexus-logo-1988-1920x1080.png', country: 'Japan' },
  { id: 'infiniti', name: 'Infiniti', nameAr: 'إنفينيتي', logo: 'https://www.carlogos.org/car-logos/infiniti-logo-1989-2560x1440.png', country: 'Japan' },
  { id: 'mitsubishi', name: 'Mitsubishi', nameAr: 'ميتسوبيشي', logo: 'https://www.carlogos.org/car-logos/mitsubishi-logo-2000x900.png', country: 'Japan' },
  { id: 'mazda', name: 'Mazda', nameAr: 'مازدا', logo: 'https://www.carlogos.org/car-logos/mazda-logo-1997-1920x1080.png', country: 'Japan' },
  { id: 'suzuki', name: 'Suzuki', nameAr: 'سوزوكي', logo: 'https://www.carlogos.org/car-logos/suzuki-logo-1920x1080.png', country: 'Japan' },
  { id: 'mercedes', name: 'Mercedes-Benz', nameAr: 'مرسيدس بنز', logo: 'https://www.carlogos.org/car-logos/mercedes-benz-logo-2011-1920x1080.png', country: 'Germany' },
  { id: 'bmw', name: 'BMW', nameAr: 'بي إم دبليو', logo: 'https://www.carlogos.org/car-logos/bmw-logo-2020-gray.png', country: 'Germany' },
  { id: 'audi', name: 'Audi', nameAr: 'أودي', logo: 'https://www.carlogos.org/car-logos/audi-logo-2016-1920x1080.png', country: 'Germany' },
  { id: 'volkswagen', name: 'Volkswagen', nameAr: 'فولكس فاجن', logo: 'https://www.carlogos.org/car-logos/volkswagen-logo-2019-1500x1500.png', country: 'Germany' },
  { id: 'porsche', name: 'Porsche', nameAr: 'بورش', logo: 'https://www.carlogos.org/car-logos/porsche-logo-2100x1100.png', country: 'Germany' },
  { id: 'ford', name: 'Ford', nameAr: 'فورد', logo: 'https://www.carlogos.org/car-logos/ford-logo-2017-1500x1101.png', country: 'USA' },
  { id: 'chevrolet', name: 'Chevrolet', nameAr: 'شيفروليه', logo: 'https://www.carlogos.org/car-logos/chevrolet-logo-2013-2560x1440.png', country: 'USA' },
  { id: 'gmc', name: 'GMC', nameAr: 'جي إم سي', logo: 'https://www.carlogos.org/car-logos/gmc-logo-2200x700.png', country: 'USA' },
  { id: 'dodge', name: 'Dodge', nameAr: 'دودج', logo: 'https://www.carlogos.org/car-logos/dodge-logo-1990-2100x2100.png', country: 'USA' },
  { id: 'jeep', name: 'Jeep', nameAr: 'جيب', logo: 'https://www.carlogos.org/car-logos/jeep-logo-1993-1920x1080.png', country: 'USA' },
  { id: 'cadillac', name: 'Cadillac', nameAr: 'كاديلاك', logo: 'https://www.carlogos.org/car-logos/cadillac-logo-2014-1920x1080.png', country: 'USA' },
  { id: 'hyundai', name: 'Hyundai', nameAr: 'هيونداي', logo: 'https://www.carlogos.org/car-logos/hyundai-logo-2011-1920x1080.png', country: 'Korea' },
  { id: 'kia', name: 'Kia', nameAr: 'كيا', logo: 'https://www.carlogos.org/car-logos/kia-logo-2021-2560x1440.png', country: 'Korea' },
  { id: 'genesis', name: 'Genesis', nameAr: 'جينيسيس', logo: 'https://www.carlogos.org/car-logos/genesis-logo-2015-1920x1080.png', country: 'Korea' },
  { id: 'land-rover', name: 'Land Rover', nameAr: 'لاند روفر', logo: 'https://www.carlogos.org/car-logos/land-rover-logo-2011-1920x1080.png', country: 'UK' },
  { id: 'jaguar', name: 'Jaguar', nameAr: 'جاكوار', logo: 'https://www.carlogos.org/car-logos/jaguar-logo-2012-1920x1080.png', country: 'UK' },
  { id: 'bentley', name: 'Bentley', nameAr: 'بنتلي', logo: 'https://www.carlogos.org/car-logos/bentley-logo-1920x1080.png', country: 'UK' },
  { id: 'rolls-royce', name: 'Rolls-Royce', nameAr: 'رولز رويس', logo: 'https://www.carlogos.org/car-logos/rolls-royce-logo-1920x1080.png', country: 'UK' },
  { id: 'ferrari', name: 'Ferrari', nameAr: 'فيراري', logo: 'https://www.carlogos.org/car-logos/ferrari-logo-750x1100.png', country: 'Italy' },
  { id: 'lamborghini', name: 'Lamborghini', nameAr: 'لامبورغيني', logo: 'https://www.carlogos.org/car-logos/lamborghini-logo-1920x1080.png', country: 'Italy' },
  { id: 'maserati', name: 'Maserati', nameAr: 'مازيراتي', logo: 'https://www.carlogos.org/car-logos/maserati-logo-2006-1920x1080.png', country: 'Italy' },
  { id: 'volvo', name: 'Volvo', nameAr: 'فولفو', logo: 'https://www.carlogos.org/car-logos/volvo-logo-2014-1920x1080.png', country: 'Sweden' },
];

// Group brands by country
const countries = {
  Japan: { name: 'Japan', nameAr: 'اليابان', flag: '🇯🇵' },
  Germany: { name: 'Germany', nameAr: 'ألمانيا', flag: '🇩🇪' },
  USA: { name: 'USA', nameAr: 'أمريكا', flag: '🇺🇸' },
  Korea: { name: 'Korea', nameAr: 'كوريا', flag: '🇰🇷' },
  UK: { name: 'UK', nameAr: 'بريطانيا', flag: '🇬🇧' },
  Italy: { name: 'Italy', nameAr: 'إيطاليا', flag: '🇮🇹' },
  Sweden: { name: 'Sweden', nameAr: 'السويد', flag: '🇸🇪' },
};

export default function CarPartsBrands() {
  const { isDarkMode } = useTheme();
  const { language } = useLanguage();
  const isAr = language === 'ar';
  
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCountry, setSelectedCountry] = useState('all');

  // Filter brands
  const filteredBrands = carBrands.filter(brand => {
    const matchesSearch = brand.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         brand.nameAr.includes(searchQuery);
    const matchesCountry = selectedCountry === 'all' || brand.country === selectedCountry;
    return matchesSearch && matchesCountry;
  });

  // Group filtered brands by country
  const groupedBrands = filteredBrands.reduce((acc, brand) => {
    if (!acc[brand.country]) acc[brand.country] = [];
    acc[brand.country].push(brand);
    return acc;
  }, {});

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-[#0a0a0a]' : 'bg-gray-50'}`}>
      {/* Hero Section */}
      <section className={`relative py-12 sm:py-16 ${isDarkMode ? 'bg-gradient-to-b from-orange-500/20 to-transparent' : 'bg-gradient-to-b from-orange-500/10 to-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4 ${isDarkMode ? 'bg-orange-500/20 text-orange-400' : 'bg-orange-500/10 text-orange-600'}`}>
              <Car className="w-5 h-5" />
              <span className="text-sm font-medium">{isAr ? 'قطع غيار السيارات' : 'Car Spare Parts'}</span>
            </div>
            <h1 className={`text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-[#0f172a]'}`}>
              {isAr ? 'اختر ماركة السيارة' : 'Select Car Brand'}
            </h1>
            <p className={`text-lg max-w-2xl mx-auto ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              {isAr ? 'اختر ماركة سيارتك للعثور على القطع المناسبة' : 'Choose your car brand to find the right parts'}
            </p>
          </div>
        </div>
      </section>

      {/* Search and Filters */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className={`rounded-2xl p-4 ${isDarkMode ? 'bg-[#141414] border border-white/10' : 'bg-white shadow-sm'}`}>
          <div className="flex flex-col sm:flex-row gap-4 items-center">
            {/* Search */}
            <div className="relative flex-1 w-full">
              <Search className={`absolute ${isAr ? 'right-4' : 'left-4'} top-1/2 -translate-y-1/2 w-5 h-5 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`} />
              <input
                type="text"
                placeholder={isAr ? 'ابحث عن ماركة...' : 'Search brand...'}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className={`w-full ${isAr ? 'pr-12 pl-4' : 'pl-12 pr-4'} py-3 rounded-xl text-base transition-all ${isDarkMode ? 'bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:border-orange-500/50' : 'bg-gray-50 border border-gray-200 text-[#0f172a] placeholder-gray-400 focus:border-orange-500'} focus:outline-none focus:ring-2 focus:ring-orange-500/20`}
                data-testid="search-brand"
              />
            </div>

            {/* Country Filter */}
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => setSelectedCountry('all')}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${selectedCountry === 'all' ? 'bg-orange-500 text-white' : isDarkMode ? 'bg-white/5 text-gray-400 hover:bg-white/10' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
              >
                {isAr ? 'الكل' : 'All'}
              </button>
              {Object.entries(countries).map(([key, country]) => (
                <button
                  key={key}
                  onClick={() => setSelectedCountry(key)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${selectedCountry === key ? 'bg-orange-500 text-white' : isDarkMode ? 'bg-white/5 text-gray-400 hover:bg-white/10' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
                >
                  <span>{country.flag}</span>
                  <span className="hidden sm:inline">{isAr ? country.nameAr : country.name}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Results count */}
        <div className={`mt-4 text-sm ${isDarkMode ? 'text-gray-500' : 'text-gray-500'}`}>
          {isAr ? `${filteredBrands.length} ماركة` : `${filteredBrands.length} brands`}
        </div>
      </section>

      {/* Brands Grid by Country */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        {selectedCountry === 'all' ? (
          // Show grouped by country
          Object.entries(groupedBrands).map(([countryKey, brands]) => (
            <div key={countryKey} className="mb-10">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-2xl">{countries[countryKey]?.flag}</span>
                <h2 className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-[#0f172a]'}`}>
                  {isAr ? countries[countryKey]?.nameAr : countries[countryKey]?.name}
                </h2>
                <div className={`flex-1 h-px ${isDarkMode ? 'bg-white/10' : 'bg-gray-200'}`}></div>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
                {brands.map((brand) => (
                  <BrandCard key={brand.id} brand={brand} isDarkMode={isDarkMode} isAr={isAr} />
                ))}
              </div>
            </div>
          ))
        ) : (
          // Show flat grid for selected country
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
            {filteredBrands.map((brand) => (
              <BrandCard key={brand.id} brand={brand} isDarkMode={isDarkMode} isAr={isAr} />
            ))}
          </div>
        )}

        {filteredBrands.length === 0 && (
          <div className={`text-center py-20 rounded-2xl ${isDarkMode ? 'bg-[#141414]' : 'bg-white'}`}>
            <Car className={`h-16 w-16 mx-auto mb-4 ${isDarkMode ? 'text-gray-700' : 'text-gray-300'}`} />
            <p className={`text-xl font-medium mb-2 ${isDarkMode ? 'text-white' : 'text-[#0f172a]'}`}>
              {isAr ? 'لا توجد نتائج' : 'No results found'}
            </p>
            <p className={`${isDarkMode ? 'text-gray-500' : 'text-gray-500'}`}>
              {isAr ? 'جرب البحث بكلمة أخرى' : 'Try a different search term'}
            </p>
          </div>
        )}
      </section>
    </div>
  );
}

// Brand Card Component
function BrandCard({ brand, isDarkMode, isAr }) {
  return (
    <Link
      to={`/spare-parts/${brand.id}`}
      className={`group rounded-2xl p-4 transition-all hover:scale-[1.02] flex flex-col items-center justify-center text-center ${isDarkMode ? 'bg-[#141414] border border-white/10 hover:border-orange-500/50 hover:shadow-lg hover:shadow-orange-500/10' : 'bg-white border border-gray-200 hover:border-orange-500/50 hover:shadow-lg'}`}
      data-testid={`brand-${brand.id}`}
    >
      {/* Logo */}
      <div className={`w-20 h-20 sm:w-24 sm:h-24 rounded-xl flex items-center justify-center mb-3 p-3 transition-all group-hover:scale-110 ${isDarkMode ? 'bg-white/5' : 'bg-gray-50'}`}>
        <img 
          src={brand.logo} 
          alt={brand.name}
          className="w-full h-full object-contain"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = `https://ui-avatars.com/api/?name=${brand.name}&background=random&size=100`;
          }}
        />
      </div>

      {/* Name */}
      <h3 className={`font-semibold ${isDarkMode ? 'text-white' : 'text-[#0f172a]'}`}>
        {isAr ? brand.nameAr : brand.name}
      </h3>

      {/* Arrow */}
      <div className={`mt-2 opacity-0 group-hover:opacity-100 transition-opacity ${isDarkMode ? 'text-orange-400' : 'text-orange-500'}`}>
        {isAr ? <ChevronLeft className="w-5 h-5" /> : <ChevronRight className="w-5 h-5" />}
      </div>
    </Link>
  );
}
